import { useContactsModal } from '~/features/contacts-modal';

export default defineNuxtPlugin(() => {
  const { openContactsModalIfHashExists, closeContactsModalIfHashEmpty } = useContactsModal();
  const route = useRoute();

  watch(route, (to, from) => {
    openContactsModalIfHashExists();
    closeContactsModalIfHashEmpty();
  }, { immediate: true });
});
